// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.experiment-panel-form {
    width: 100%;
    margin-bottom: 1.5rem;
}

.experiment-panel-row {
    display: grid;
    grid-template-columns: 200px 390px;
    justify-content: center;
    align-items: center;
    column-gap: 20px;
    width: 100%;
    margin-bottom: 1rem;
    box-sizing: border-box;
}

.experiment-panel-label {
    margin: 0;
    text-align: right;
    white-space: nowrap;
}

.experiment-panel-control {
    width: 100%;
    min-width: 0;
    text-align: left;
}

.experiment-panel-calculation {
    display: block;
    margin-top: 0.5rem;
    color: #888;
    font-size: 0.95rem;
    line-height: 1.4;
    text-align: left;
    white-space: normal;
}

.experiment-panel-name {
    width: 185px;
}

.experiment-panel-type {
    width: 218px;
}

.experiment-panel-levels {
    width: 100%;
}

.experiment-panel-levels .p-inputnumber-input {
    width: 100%;
}

.experiment-panel-response {
    width: 312px;
}

.experiment-panel-parameters {
    width: 390px;
}

@media screen and (max-width: 700px) {
    .experiment-panel-row {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 0.5rem;
        padding: 0 1rem;
    }

    .experiment-panel-label {
        text-align: left;
    }

    .experiment-panel-control,
    .experiment-panel-name,
    .experiment-panel-type,
    .experiment-panel-levels,
    .experiment-panel-response,
    .experiment-panel-parameters {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/configuration/ExperimentPanel.css"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,oBAAoB;QACpB,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;;;;;QAMI,WAAW;IACf;AACJ","sourcesContent":["\n.experiment-panel-form {\n    width: 100%;\n    margin-bottom: 1.5rem;\n}\n\n.experiment-panel-row {\n    display: grid;\n    grid-template-columns: 200px 390px;\n    justify-content: center;\n    align-items: center;\n    column-gap: 20px;\n    width: 100%;\n    margin-bottom: 1rem;\n    box-sizing: border-box;\n}\n\n.experiment-panel-label {\n    margin: 0;\n    text-align: right;\n    white-space: nowrap;\n}\n\n.experiment-panel-control {\n    width: 100%;\n    min-width: 0;\n    text-align: left;\n}\n\n.experiment-panel-calculation {\n    display: block;\n    margin-top: 0.5rem;\n    color: #888;\n    font-size: 0.95rem;\n    line-height: 1.4;\n    text-align: left;\n    white-space: normal;\n}\n\n.experiment-panel-name {\n    width: 185px;\n}\n\n.experiment-panel-type {\n    width: 218px;\n}\n\n.experiment-panel-levels {\n    width: 100%;\n}\n\n.experiment-panel-levels .p-inputnumber-input {\n    width: 100%;\n}\n\n.experiment-panel-response {\n    width: 312px;\n}\n\n.experiment-panel-parameters {\n    width: 390px;\n}\n\n@media screen and (max-width: 700px) {\n    .experiment-panel-row {\n        display: flex;\n        flex-direction: column;\n        align-items: stretch;\n        gap: 0.5rem;\n        padding: 0 1rem;\n    }\n\n    .experiment-panel-label {\n        text-align: left;\n    }\n\n    .experiment-panel-control,\n    .experiment-panel-name,\n    .experiment-panel-type,\n    .experiment-panel-levels,\n    .experiment-panel-response,\n    .experiment-panel-parameters {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
